module.exports = __webpack_public_path__ + "static/media/asxpert.e0fa915e.png";